import React from 'react';
import CircleSection from '../../Helpers/Circles/CircleSection';
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../../sessionStorage';

import './Marketing.scss';

export default function Marketing() {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  var accountName = accountObj && accountObj.accountDisplayName ? accountObj.accountDisplayName : accountObj && accountObj.account ? accountObj.account.accountName : "Covr";
  const data = [
    {
      image: "home/circle1.png",
      textContent: <div className="text w-100">
        <h2>You can buy TODAY... really!</h2>
        <p>Historically, buying life insurance has been a long, slow, frustrating process. {accountName} is changing that with fast, simple life insurance you can buy online right now. Our application process is streamlined every step of the way and will match you with the best available product, at the best price for you and your family.</p>
      </div>
    },
  ]

  return (
    <div className="marketing justify-content-center">
      <CircleSection data={data} reverse />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Home/Marketing/Marketing.js